import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import AuthGuard from "./auth-guard";

Vue.use(Router);

export default new Router({
  base: process.env.BASE_URL,
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      beforeEnter: AuthGuard
    },
    {
      path: "/appointments",
      name: "appointments",
      component: () =>
        import(/* webpackChunkName: "people" */ "./views/Appointments.vue"),
      beforeEnter: AuthGuard
    },
    {
      path: "/appointments/:id",
      name: "appointmentDetails",
      component: () =>
        import(/* webpackChunkName: "people" */ "./views/AppointmentDetails.vue"),
      beforeEnter: AuthGuard
    },
    {
      path: "/people",
      name: "people",
      component: () =>
        import(/* webpackChunkName: "people" */ "./views/People.vue"),
      beforeEnter: AuthGuard
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Login.vue")
    },
    {
      path: "/application/:id",
      name: "mainApplication",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Application.vue")
    },
    {
      path: "/application/:id/:applicantID",
      name: "application",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Application.vue")
    }
  ]
});
